<template>
  <el-dialog
    title="添加"
    :visible.sync="dialogVisible"
    width="40%"
    class="addIndustryDialog"
    @close="dialogCloseHandle"
  >
    <el-form class="common_form" label-position="left" ref="addIndustryFrom" :rules="rules" label-width="120px" :model="formData">
      <el-row>
        <el-col :span="24">
          <el-form-item label="行业" prop="industryName">
            <div class="agendaRow">
              <el-input v-model="formData.industryName" />
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="活动议程">
            <div class="agendaRow" v-for="(item,index) in agendaList.length" :key="index">
              <el-input v-model="agendaList[index]" />
              <i class="iconfont icon--s-guanbi" v-show="index !== 0 && agendaList.length > 1" @click="agendaDelBtn(index)" />
            </div>
            <el-button type="primary" @click="agendaAddBtn">添加</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button plain @click="dialogCloseHandle">取消</el-button>
      <el-button type="primary" @click="submitHandlen">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      rules: {
        industryName: [
          { required: true, message: '请输入行业', trigger: 'blur' }
        ]
      },
      formData: {},
      dialogVisible: false,
      agendaList: ['']
    };
  },
  props: {
    addIndustryDialogShow: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  watch: {
    addIndustryDialogShow (val) {
      if (val) {
        if (this.rowData.id) {
          this.formData = this.rowData;
          if (this.rowData.manageIndustryAgendaList && this.rowData.manageIndustryAgendaList.length > 0) {
            this.agendaList = this.rowData.manageIndustryAgendaList.map(item => {
              return item.agenda;
            });
          } else {
            this.agendaList = [''];
          }
        }
      } else {
        this.formData = {};
        this.agendaList = [''];
        this.$nextTick(() => {
          this.$refs.addIndustryFrom.clearValidate();
        });
      }
      this.dialogVisible = val;
    }
  },
  methods: {
    agendaDelBtn (index) {
      this.agendaList.splice(index, 1);
    },
    agendaAddBtn () {
      this.agendaList.push('');
    },
    dialogCloseHandle () {
      this.$emit('dialogClose');
    },
    submitHandlen () {
      this.$refs['addIndustryFrom'].validate((valid) => {
        if (valid) {
          let params = {
            industryName: this.formData.industryName
          };
          // 活动议程数组处理
          // 过滤掉空值
          let activityAgenda = this.agendaList.filter(item => item);
          params.activityAgenda = activityAgenda.map((item, index) => {
            return {
              agenda: item,
              orderNum: index + 1
            };
          });
          if (this.formData.id) {
            params.id = this.formData.id;
            this.$emit('editIndustryHandle', params);
          } else {
            this.$emit('addIndustryHandle', params);
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.agendaRow{
  padding-right: 36px;
  position: relative;
  >.el-input{
    margin-bottom: 10px;
  }
  >i{
    color: #DC5650;
    font-size: 16px;
    position: absolute;
    top: 0;
    right: 8px;
    cursor: pointer;
  }
}
//.customStyle{
//  .agendaRow{
//    position: relative;
//  }
//  .agendaRow+.agendaRow{
//    margin-top: 10px;
//  }
//  .agendaRow>button{
//    position: absolute;
//    right: -44px;
//  }
//}

</style>
